/**
 * Herkunft übernommener Angaben: Quelle mit Verweis, Lizenz der Daten und
 * des Bilds und das Datum der Übernahme. Die Lizenzen (ODbL, CC BY-SA)
 * verlangen diese Nennung.
 */
import type { ProvenanceEntry } from '../../api/types.ts';
import { texts } from '../../texts/de.ts';

/** Kurze Liste der Quellen. */
export function Provenance({ entries }: { readonly entries: readonly ProvenanceEntry[] }) {
  if (entries.length === 0) {
    return null;
  }
  return (
    <ul className="space-y-0.5 text-xs text-content-muted">
      {entries.map((entry) => (
        <li key={`${entry.source}-${entry.url ?? ''}-${entry.at}`}>
          {texts.scan.from}{' '}
          {entry.url === null ? (
            entry.label
          ) : (
            <a href={entry.url} target="_blank" rel="noreferrer" className="underline">
              {entry.label}
            </a>
          )}
          {' · '}
          {/* Bei Bildern aus Commons ist die Lizenz der Daten die des Bilds; dann nur einmal nennen. */}
          {entry.imageLicense === entry.license
            ? `${texts.scan.imageLicense} ${entry.imageLicense}`
            : `${texts.scan.dataLicense} ${entry.license}${
                entry.imageLicense === null ? '' : ` · ${texts.scan.imageLicense} ${entry.imageLicense}`
              }`}
          {' · '}
          {new Date(entry.at).toLocaleDateString('de-DE')}
        </li>
      ))}
    </ul>
  );
}
